if (!customElements.get('save-co2-calculator')) {
  customElements.define(
    'save-co2-calculator',
    class SaveCo2Calculator extends HTMLElement {
      constructor() {
        super();
        this.updateCo2 = this.updateCo2.bind(this);
      }

      get sectionId() {
        return this.getAttribute('data-section-id');
      }

      get initialQuantity() {
        return parseInt(this.getAttribute('data-initial-quantity')) || 1;
      }

      get co2Multiplier() {
        // Check if data-co2 is set on this element
        const co2Attr = this.getAttribute('data-co2');
        if (co2Attr !== null) {
          return parseFloat(co2Attr) || 10;
        }
        // Check parent div for data-co2 attribute
        const parentDiv = this.closest('.save-co2');
        if (parentDiv) {
          const parentCo2 = parentDiv.getAttribute('data-co2');
          if (parentCo2 !== null) {
            return parseFloat(parentCo2) || 10;
          }
        }
        // Default to 10 if not found
        return 10;
      }

      connectedCallback() {
        // Wait a bit for the quantity input to be available
        setTimeout(() => {
          this.quantityInput = document.getElementById(`Quantity-${this.sectionId}`);
          this.co2Span = this.querySelector('.saved-co2');
          
          if (this.quantityInput && this.co2Span) {
            // Update CO2 on initial load
            this.updateCo2();
            
            // Listen for quantity input changes
            this.quantityInput.addEventListener('change', this.updateCo2);
            this.quantityInput.addEventListener('input', this.updateCo2);
            
            // Also listen for quantity button clicks (plus/minus) via the quantity-input element
            const quantityInputElement = this.quantityInput.closest('quantity-input');
            if (quantityInputElement) {
              quantityInputElement.addEventListener('change', this.updateCo2);
            }
            
            // Use MutationObserver to catch programmatic value changes
            this.observer = new MutationObserver(() => {
              this.updateCo2();
            });
            this.observer.observe(this.quantityInput, {
              attributes: true,
              attributeFilter: ['value']
            });
          }
        }, 100);
      }

      disconnectedCallback() {
        if (this.quantityInput) {
          this.quantityInput.removeEventListener('change', this.updateCo2);
          this.quantityInput.removeEventListener('input', this.updateCo2);
        }
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      updateCo2() {
        if (this.quantityInput && this.co2Span) {
          const quantity = parseInt(this.quantityInput.value) || this.initialQuantity;
          const co2Saved = quantity * this.co2Multiplier;
          this.co2Span.textContent = co2Saved;
        }
      }
    }
  );
}
